module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.25941/images/keyFeatures/Trusted_Responses.png"